module.exports = __webpack_public_path__ + "static/media/004-Nicht-Desinfiziert_ID_1.fd10ab93.mp3";